import videoCompiled from './video-shared.hbs';
import { Context } from './types';
import { TypeSafeTemplateDelegate } from '../../../Utility/Handlebars/types';

interface VideoContext {
    videoElementId: string | number;
    announcement: {
        background_color: string;
    };
}

export const videoTemplate: TypeSafeTemplateDelegate<Context<VideoContext>> = videoCompiled;
